export default class ExternalIdentityProvider {
  id: string;
  name: string;
}
